import ImageNext from 'next/image'

import { imageLoader } from '@/utils/imageLoader'

import type { ImageProps } from 'next/image'

// Images load lazily, Next.js's default, unless `priority` is set, which above-the-fold images such as the
// page's Largest Contentful Paint should use.
const Image: React.FC<ImageProps> = props => {
  return <ImageNext loader={imageLoader} {...props} />
}

export default Image
